import { api } from '@/utils/api';
export function useGetPayInsiderToken() {
  const { isLoading, mutateAsync, data } =
    api.subLog.getPayInsiderToken.useMutation()
  return {
    getPayInsiderLoading: isLoading,
    getPayInsiderToken: mutateAsync,
    payInsiderPayInfo: data,
  }
}

export type TUseGetPayInsiderToken = ReturnType<typeof useGetPayInsiderToken>
